import React, { useState } from "react";
import { EuiFormRow, EuiCheckbox } from "@elastic/eui";

import _ from "lodash";

function AbstractCheckbox({ options, errors, register, onChange, isChecked }) {
    const [value, setValue] = useState(isChecked);

    const handleChange = ({ target: { checked } }) => {
        setValue(checked);
        if (onChange) {
            onChange(checked);
        }
    };

    return (
        <EuiFormRow
            fullWidth
            key={options.name}
            helpText={options.helpText}
            isInvalid={errors && !_.isNil(errors[options.name])}
            error={options.errorMessage}
        >
            <EuiCheckbox
                id={options.name}
                label={options.label}
                checked={value}
                onChange={handleChange}
                name={options.name}
                inputRef={register({
                    ...options.validation,
                })}
            />
        </EuiFormRow>
    );
}

export default AbstractCheckbox;
